var _path, _path2, _path3, _path4, _mask, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 970,
    height: 1336,
    viewBox: "0 0 970 1336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.691 179.38C538.225 179.38 578.381 139.224 578.381 89.69C578.381 40.1556 538.225 0 488.691 0C439.157 0 399.001 40.1556 399.001 89.69C399.001 139.224 439.157 179.38 488.691 179.38Z",
    fill: "#3D1477"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M487.791 159.51C515.958 159.51 538.791 136.677 538.791 108.51C538.791 80.3435 515.958 57.51 487.791 57.51C459.624 57.51 436.791 80.3435 436.791 108.51C436.791 136.677 459.624 159.51 487.791 159.51Z",
    fill: "#E8E7EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1211 544.65C65.1211 544.65 132.781 174.51 463.791 174.51C835.791 174.51 915.111 591.9 915.111 591.9L65.1211 544.65Z",
    fill: "#0B8E86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7504 1225.4C18.7504 1225.4 -122.25 232.3 459.8 232.3C1067.11 232.3 966.85 1111.39 957.8 1225.4C948.75 1339.41 174.77 1393.42 18.7504 1225.4Z",
    fill: "#69F3EA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 232,
    width: 967,
    height: 1101
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7504 1225.4C18.7504 1225.4 -122.25 232.3 459.8 232.3C1067.11 232.3 966.85 1111.39 957.8 1225.4C948.75 1339.41 174.77 1393.42 18.7504 1225.4Z",
    fill: "#7BE0F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M953.84 649.93C919.38 616.54 853.71 612.85 794.27 644.25C736.27 674.9 702.53 729.25 708.51 775.81C707.02 776.55 705.51 777.3 704.05 778.09C634.56 814.79 599.89 885.55 626.61 936.09C653.33 986.63 731.31 997.9 800.8 961.19C846.8 936.9 877.5 897.7 885.29 859.31C921.4 874.51 971.1 871.22 1017.08 846.93C1086.56 810.22 1121.23 739.47 1094.51 688.93C1072 646.39 1013.29 631.68 953.84 649.93Z",
    fill: "#F5FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.921 980.55C431.141 956.55 383.921 953.88 341.161 976.46C299.451 998.46 275.161 1037.6 279.481 1071.08C278.411 1071.61 277.341 1072.15 276.281 1072.71C226.281 1099.11 201.371 1150 220.591 1186.37C239.811 1222.74 295.891 1230.82 345.861 1204.42C378.921 1186.95 401.021 1158.76 406.621 1131.15C432.621 1142.08 468.331 1139.72 501.401 1122.25C551.401 1095.85 576.311 1044.96 557.091 1008.59C540.931 978 498.681 967.42 455.921 980.55Z",
    fill: "#F5FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.621 637.35C562.831 613.35 515.621 610.67 472.861 633.26C431.141 655.26 406.861 694.4 411.181 727.87C410.111 728.4 409.041 728.95 407.971 729.51C357.971 755.91 333.071 806.79 352.281 843.16C371.491 879.53 427.581 887.62 477.551 861.22C510.621 843.75 532.721 815.56 538.321 787.94C564.321 798.88 600.031 796.51 633.101 779.04C683.101 752.64 708.001 701.76 688.791 665.39C672.621 634.8 630.371 624.22 587.621 637.35Z",
    fill: "#F5FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.431 851.05C147.641 827.05 100.431 824.37 57.6706 846.96C16.0006 869 -8.2994 908.1 -3.9994 941.57C-5.0694 942.1 -6.1394 942.65 -7.2094 943.21C-57.2094 969.61 -82.1094 1020.49 -62.8894 1056.86C-43.6694 1093.23 12.4106 1101.32 62.3806 1074.92C95.4406 1057.45 117.541 1029.26 123.141 1001.64C149.141 1012.58 184.851 1010.21 217.921 992.74C267.921 966.34 292.821 915.46 273.611 879.09C257.441 848.5 215.191 837.92 172.431 851.05Z",
    fill: "#F5FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18 570.27C163.4 546.27 116.18 543.6 73.4205 566.19C31.7105 588.19 7.42048 627.32 11.7405 660.8C10.6705 661.33 9.60048 661.87 8.54048 662.44C-41.4595 688.84 -66.3695 739.72 -47.1495 776.09C-27.9295 812.46 28.1505 820.54 78.1205 794.15C111.19 776.68 133.28 748.48 138.89 720.87C164.89 731.81 200.59 729.44 233.66 711.97C283.66 685.57 308.57 634.69 289.35 598.32C273.19 567.72 230.94 557.15 188.18 570.27Z",
    fill: "#F5FDFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.56
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73081 977.87C3.73081 977.87 491.381 1142.33 969.211 1004V1028C969.211 1028 388.841 1197.25 3.89081 997.82C-4.76919 993.33 3.73081 988.07 3.73081 977.87Z",
    fill: "#0B8E86"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M692.049 824.457L613.796 796.253L429.595 1307.33L507.847 1335.54L692.049 824.457Z",
    fill: "#FFE100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M608.961 814.14L661.601 833.11",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M594.781 853.49L647.411 872.46",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M604.23 826.9L630.38 836.86",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M599.381 840.15L625.531 850.11",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M594.871 853.53L647.501 872.5",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M580.681 892.88L633.321 911.85",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M590.131 866.29L616.281 876.25",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M585.291 879.54L611.441 889.5",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M580.771 892.92L633.411 911.89",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M566.591 932.27L619.221 951.25",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M576.041 905.68L602.191 915.64",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M571.19 918.93L597.34 928.89",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M566.501 932.24L619.131 951.21",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M552.311 971.6L604.951 990.57",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M561.761 945L587.911 954.96",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M556.921 958.26L583.071 968.22",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M552.491 971.66L605.131 990.64",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M538.311 1011.02L590.941 1029.99",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M547.761 984.43L573.901 994.38",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M542.911 997.68L569.061 1007.64",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M538.4 1011.06L591.03 1030.03",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M524.211 1050.41L576.851 1069.38",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M533.661 1023.82L559.811 1033.78",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M528.82 1037.07L554.96 1047.03",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M524.301 1050.45L576.941 1069.42",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M510.121 1089.8L562.751 1108.77",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M545.71 1073.17L519.57 1063.21",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M514.721 1076.46L540.871 1086.42",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M919.266 870.642L849.487 802.975L406.553 1259.73L476.332 1327.4L919.266 870.642Z",
    fill: "#FA4692"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M835.48 819.59L882.52 865.21",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M801.371 854.76L848.411 900.38",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M824.281 830.93L847.391 854.16",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M812.721 842.74L835.821 865.97",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M801.451 854.84L848.491 900.46",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M767.341 890.01L814.371 935.63",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M790.241 866.18L813.351 889.41",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M778.681 877.99L801.791 901.22",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M767.421 890.09L814.451 935.71",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M733.301 925.26L780.341 970.88",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M756.211 901.43L779.321 924.66",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M744.65 913.24L767.76 936.47",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M733.221 925.18L780.261 970.8",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M699.11 960.35L746.15 1005.98",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M722.021 936.52L745.131 959.75",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M710.461 948.33L733.571 971.57",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M699.271 960.51L746.311 1006.13",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M665.161 995.68L712.191 1041.3",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M688.07 971.85L711.17 995.08",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M676.501 983.66L699.611 1006.9",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M665.241 995.76L712.271 1041.38",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M631.121 1030.93L678.161 1076.55",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M654.031 1007.1L677.141 1030.33",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M642.471 1018.91L665.581 1042.15",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M631.201 1031.01L678.241 1076.63",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M597.091 1066.18L644.131 1111.8",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M620.001 1042.35L643.111 1065.58",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M608.44 1054.16L631.55 1077.4",
    stroke: "#3D1477",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.51
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M663.291 1066C684.291 1062 733.571 1062 733.571 1062L694.291 1095L527.801 1105.9L480.801 1090.44",
    fill: "#0B8E86"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89062 997.82C3.89062 997.82 368.381 1184.35 969.211 1028",
    stroke: "#69F3EA",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M904.051 559.68C837.591 378.66 707.591 232.3 459.801 232.3C252.491 232.3 136.911 358.3 74.0107 520.49C198.881 614.51 486.201 761 904.051 559.68Z",
    fill: "#10C9BE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M178.101 560.4C186.799 560.4 193.851 553.349 193.851 544.65C193.851 535.952 186.799 528.9 178.101 528.9C169.402 528.9 162.351 535.952 162.351 544.65C162.351 553.349 169.402 560.4 178.101 560.4Z",
    fill: "#F5FDFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M304.091 607.65C312.789 607.65 319.841 600.599 319.841 591.9C319.841 583.202 312.789 576.15 304.091 576.15C295.392 576.15 288.341 583.202 288.341 591.9C288.341 600.599 295.392 607.65 304.091 607.65Z",
    fill: "#F5FDFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M442.08 639.16C450.779 639.16 457.83 632.108 457.83 623.41C457.83 614.711 450.779 607.66 442.08 607.66C433.382 607.66 426.33 614.711 426.33 623.41C426.33 632.108 433.382 639.16 442.08 639.16Z",
    fill: "#F5FDFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M565.99 639.16C574.689 639.16 581.74 632.108 581.74 623.41C581.74 614.711 574.689 607.66 565.99 607.66C557.292 607.66 550.24 614.711 550.24 623.41C550.24 632.108 557.292 639.16 565.99 639.16Z",
    fill: "#F5FDFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M687.32 607.65C696.019 607.65 703.07 600.599 703.07 591.9C703.07 583.202 696.019 576.15 687.32 576.15C678.622 576.15 671.57 583.202 671.57 591.9C671.57 600.599 678.622 607.65 687.32 607.65Z",
    fill: "#F5FDFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M808.061 576.15C816.759 576.15 823.811 569.099 823.811 560.4C823.811 551.702 816.759 544.65 808.061 544.65C799.362 544.65 792.311 551.702 792.311 560.4C792.311 569.099 799.362 576.15 808.061 576.15Z",
    fill: "#F5FDFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M233.631 280.77C233.631 280.77 236.491 274.37 315.841 238.9C339.841 131.05 523.001 -0.460007 646.001 242.54C653.381 254.4 686.271 257.89 706.001 266.54C722.551 273.8 728.261 265.98 722.371 248.88C699.121 181.41 632.051 68.54 453.831 68.49C284.001 68.44 233.631 280.77 233.631 280.77Z",
    fill: "#0B8E86"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M466.512 465.182C480.945 462.327 486.241 427.639 478.341 387.704C470.441 347.769 452.336 317.71 437.903 320.565C423.47 323.42 418.174 358.109 426.074 398.043C433.974 437.978 452.079 468.038 466.512 465.182Z",
    fill: "#F5FDFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M467.212 461.618C475.22 460.034 476.421 432.006 469.895 399.017C463.369 366.028 451.587 340.569 443.579 342.153C435.572 343.737 434.371 371.764 440.897 404.754C447.423 437.743 459.205 463.202 467.212 461.618Z",
    fill: "#FABDED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M529.852 399.389C537.752 359.454 532.456 324.766 518.023 321.911C503.589 319.056 485.485 349.115 477.585 389.05C469.685 428.985 474.981 463.673 489.414 466.528C503.847 469.383 521.952 439.324 529.852 399.389Z",
    fill: "#F5FDFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M514.788 402.534C521.457 368.824 521.412 340.419 514.689 339.089C507.965 337.759 497.108 364.008 490.44 397.717C483.771 431.427 483.816 459.833 490.539 461.163C497.263 462.493 508.119 436.244 514.788 402.534Z",
    fill: "#FABDED"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M479.291 554.51C512.152 554.51 538.791 527.871 538.791 495.01C538.791 462.149 512.152 435.51 479.291 435.51C446.43 435.51 419.791 462.149 419.791 495.01C419.791 527.871 446.43 554.51 479.291 554.51Z",
    fill: "#F5FDFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M459.931 499.34C465.221 499.34 469.511 494.151 469.511 487.75C469.511 481.349 465.221 476.16 459.931 476.16C454.64 476.16 450.351 481.349 450.351 487.75C450.351 494.151 454.64 499.34 459.931 499.34Z",
    fill: "#3D1477"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M496.221 499.32C501.511 499.32 505.801 494.131 505.801 487.73C505.801 481.329 501.511 476.14 496.221 476.14C490.93 476.14 486.641 481.329 486.641 487.73C486.641 494.131 490.93 499.32 496.221 499.32Z",
    fill: "#3D1477"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M454.291 487.51C456.776 487.51 458.791 485.495 458.791 483.01C458.791 480.525 456.776 478.51 454.291 478.51C451.806 478.51 449.791 480.525 449.791 483.01C449.791 485.495 451.806 487.51 454.291 487.51Z",
    fill: "#F5FDFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M466.291 498.51C468.224 498.51 469.791 496.943 469.791 495.01C469.791 493.077 468.224 491.51 466.291 491.51C464.358 491.51 462.791 493.077 462.791 495.01C462.791 496.943 464.358 498.51 466.291 498.51Z",
    fill: "#F5FDFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M491.291 487.51C493.776 487.51 495.791 485.495 495.791 483.01C495.791 480.525 493.776 478.51 491.291 478.51C488.806 478.51 486.791 480.525 486.791 483.01C486.791 485.495 488.806 487.51 491.291 487.51Z",
    fill: "#F5FDFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M501.291 498.51C503.776 498.51 505.791 496.495 505.791 494.01C505.791 491.525 503.776 489.51 501.291 489.51C498.806 489.51 496.791 491.525 496.791 494.01C496.791 496.495 498.806 498.51 501.291 498.51Z",
    fill: "#F5FDFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M492.001 508C496.451 514.69 479.741 520.26 479.741 520.26C479.741 520.26 464.141 514.69 467.481 508C470.481 501.95 479.741 510.23 479.741 510.23C479.741 510.23 488.281 502.36 492.001 508Z",
    fill: "#FABDED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M606.281 178.91C620.001 196.4 633.301 217.47 646.001 242.54C653.381 254.4 686.271 257.89 706.001 266.54C710.751 268.62 714.601 269.46 717.541 269.2L724.181 263.73C724.181 263.73 620.771 195.31 606.281 178.91Z",
    fill: "#0B8E86"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M254.861 221.48C248.683 235.171 243.264 249.192 238.631 263.48C243.981 269.03 247.291 270.6 249.281 270.71L252.091 269.2C264.021 262.87 283.631 253.26 315.841 238.86C321.381 213.95 335.421 187.78 355.241 165.25C327.801 186.65 290.401 211.54 254.861 221.48Z",
    fill: "#0B8E86"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M541.411 1047.11C530.211 1152.2 508.411 1236.03 492.721 1234.36C477.031 1232.69 473.391 1146.14 484.591 1041.06C495.791 935.98 533.281 853.82 533.281 853.82C533.281 853.82 552.611 942 541.411 1047.11Z",
    fill: "#3D1477"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M543.631 937.51C539.288 938.998 534.721 939.725 530.131 939.66C521.447 939.677 513.005 936.806 506.131 931.5C509.701 918.86 513.301 907.44 516.661 897.5C519.752 899.663 523.283 901.114 527.001 901.75C527.461 901.82 527.941 901.89 528.431 901.94C532.516 902.382 536.645 901.711 540.381 900C541.591 911.46 542.381 920 542.831 926L542.981 927.85C542.981 928.07 542.981 928.29 542.981 928.52C543.031 929.13 543.081 929.74 543.121 930.35C543.201 931.59 543.291 932.83 543.371 934.08L543.491 935.98C543.561 936.47 543.601 937 543.631 937.51Z",
    fill: "#E8E7EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M541.411 1047.11C530.211 1152.2 508.411 1236.03 492.721 1234.36C490.351 1234.1 488.261 1231.91 486.461 1228.03C501.021 1208.8 518.181 1134.9 527.691 1045.65C531.324 1010.44 532.137 974.992 530.121 939.65C529.351 925.65 528.241 912.91 527.021 901.74C527.481 901.81 527.961 901.88 528.451 901.93C532.529 902.371 536.65 901.704 540.381 900C541.271 907.84 542.111 916.51 542.831 925.89V926L542.981 927.85C542.981 928.07 542.981 928.29 542.981 928.52C543.031 929.13 543.081 929.74 543.121 930.35C543.201 931.59 543.291 932.83 543.371 934.08L543.491 935.98C543.491 936.5 543.561 936.98 543.581 937.54C545.867 974.061 545.141 1010.71 541.411 1047.11Z",
    fill: "#3D1477"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M500.271 1042.73C507.501 974.85 514.571 934.21 526.561 901.42C524.561 901.21 517.031 897.82 517.031 897.82C517.031 897.82 494.511 948 483.941 1041C473.281 1134.78 476.381 1232.62 492.061 1234.3C494.901 1234.6 497.941 1232.09 501.061 1227.18C491.871 1202.43 491.091 1128.81 500.271 1042.73Z",
    fill: "#3D1477"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89062 997.82C5.23063 1129.75 18.8106 1225.4 18.8106 1225.4C174.811 1393.4 948.901 1339.4 957.901 1225.4C960.111 1197.47 967.791 1123.6 969.211 1027.99C445.261 1154.86 130.841 1056.65 3.89062 997.82Z",
    fill: "#10C9BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.51
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8109 1225.4C69.3809 1279.86 184.881 1310.99 318.221 1324.32C172.661 1272.46 66.1409 1185.41 9.4209 1130.84C13.6809 1189.28 18.8109 1225.4 18.8109 1225.4Z",
    fill: "#0B8E86"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.51
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M622.421 1327C803.491 1313.7 954.001 1275.3 957.901 1225.4C959.461 1205.66 963.761 1162.98 966.641 1105.9C916.561 1156.14 789.101 1271.1 622.421 1327Z",
    fill: "#0B8E86"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M508.791 52.51C508.791 40.912 499.389 31.51 487.791 31.51C476.193 31.51 466.791 40.912 466.791 52.51V128.51C466.791 140.108 476.193 149.51 487.791 149.51C499.389 149.51 508.791 140.108 508.791 128.51V52.51Z",
    fill: "#E8E7EC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M487.791 124.51C482.221 124.51 476.88 122.298 472.942 118.359C469.004 114.421 466.791 109.08 466.791 103.51V128.51C466.791 134.08 469.004 139.421 472.942 143.359C476.88 147.298 482.221 149.51 487.791 149.51C493.361 149.51 498.702 147.298 502.64 143.359C506.579 139.421 508.791 134.08 508.791 128.51V103.51C508.791 106.268 508.248 108.999 507.192 111.546C506.137 114.094 504.59 116.409 502.64 118.359C500.69 120.309 498.375 121.856 495.827 122.911C493.28 123.967 490.549 124.51 487.791 124.51Z",
    fill: "#69F3EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAip);
export default __webpack_public_path__ + "static/media/aip.35791b7d735419ebfe428218b771ce78.svg";
export { ForwardRef as ReactComponent };